import { addSurvey, getSurveyCount, getSurveyDetail, getSurveyReport } from "@crema/services/apis/survey";
import { appIntl } from "@crema/utility/helper/Utils";
import { ADD_SURVEY, FETCH_ERROR, FETCH_START, FETCH_SUCCESS, GET_SURVEY_COUNT, GET_SURVEY_DETAIL, GET_SURVEY_REPORT, SHOW_MESSAGE } from "shared/constants/ActionTypes";

export const onAddSurvey = (payload) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        addSurvey(payload)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: ADD_SURVEY })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Data Survey Berhasil Dikirim' })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: 'Respondent sudah mengisi survey',
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message })
            })
    };
}

export const onGetSurveyReport = (page = 1, year = '') => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getSurveyReport(page, year)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: GET_SURVEY_REPORT, payload: data })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message })
            })
    };
}

export const onGetSurveyCount = (year = '') => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getSurveyCount(year)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: GET_SURVEY_COUNT, payload: data.results })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message })
            })
    };
}

export const onGetSurveyDetail = (id) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getSurveyDetail(id)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: GET_SURVEY_DETAIL, payload: data.results })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message })
            })
    };
}